import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SubmitToRdComponent} from './submit-to-rd.component';


export const submitToRdRoutes: Routes = [
  {
    path: 'submitToRd',
    component: SubmitToRdComponent,
    data: {
      'expectedRoles': ['Accountant Admin']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(submitToRdRoutes)],
  exports: [RouterModule]
})
export class SubmitToRdRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd-routing.module.ts